export const TIMELINE_BAR_HEIGHT = '1.875rem';

export const TIMELINE_DAY_WIDTH = 240;
